import * as React from 'react';
import { graphql } from 'gatsby';
import Text from '../../components/shared/Text';
import { Image } from '../types';
import s from './ArticleTemplate.module.scss';
import {
  Vertical,
  Horizontal,
} from '../swace/gatsby-background-image/GatsbyBackgroundImage';

export interface Props {
  id: number;
  image: Image;
  caption: string;
  imagePositioning: {
    vertical: Vertical;
    horizontal: Horizontal;
  };
  internal: {
    type: string;
  };
}

class ImageBlock extends React.Component<Props> {
  render() {
    const { image, caption } = this.props;
    return (
      <div className={s.imageBlock}>
        <img
          className={s.image}
          src={image.localFile.childImageSharp.fluid.src}
        />
        <div className={s.caption}>
          <Text captionSmall>{caption}</Text>
        </div>
      </div>
    );
  }
}

export const query = graphql`
  fragment Article_ImageBlockFragment on WordPressAcf_image {
    ... on WordPressAcf_image {
      id
      image {
        localFile {
          childImageSharp {
            fluid(maxWidth: 1200, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }
      }
      imagePositioning: image_positioning {
        vertical: vertical_adjustment
        horizontal: horizontal_adjustment
      }
      caption
      internal {
        type
      }
    }
  }
`;

export default ImageBlock;
